import getHotelEncryptedMargin from 'loyalty/lib/margin/getHotelEncryptedMargin'
import getLoyaltyProductType from 'loyalty/lib/getLoyaltyProductType'
import type { PackageSelectionBurnItem } from 'components/OfferPage/packageSelection/packageSelectionBurnQuote'
import type { FlashPackageSelection } from './flashPackageSelection'

/** Only the hotel-collected part of the guest surcharge leaves points, matching checkout and the price breakdown. */
function getPropertyPayableGuestSurcharge(view: App.OfferPackageOptionView): number {
  return view.extraGuestsSurchargePayableAtProperty
}

function getFlashPackageBurnItem(id: string, offer: App.HotelOffer, view: App.OfferPackageOptionView): PackageSelectionBurnItem {
  const propertyPayableGuestSurcharge = getPropertyPayableGuestSurcharge(view)
  return {
    id,
    price: view.hotelPrice - propertyPayableGuestSurcharge,
    memberPrice: (view.hotelMemberPrice || view.hotelPrice) - propertyPayableGuestSurcharge,
    cashOnlyPrice: view.propertyFees + propertyPayableGuestSurcharge,
    loyaltyProductType: getLoyaltyProductType(offer) ?? 'hotel_flash',
    mx: getHotelEncryptedMargin(offer.type, view.package),
  }
}

export function getFlashPackageBurnItems(offer: App.HotelOffer, allocations: FlashPackageSelection['allocations']): Array<PackageSelectionBurnItem> {
  return allocations.map(({ room, view }) => getFlashPackageBurnItem(room.id, offer, view))
}

/** A same-room quote covers the complete party; calculate its booking allowance once. */
export function getFlashCombinedPackageBurnItems(offer: App.HotelOffer, view?: App.OfferPackageOptionView): Array<PackageSelectionBurnItem> {
  return view ? [getFlashPackageBurnItem(view.package.uniqueKey, offer, view)] : []
}
